import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
//import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#E2782F',
          secondary: '#0F172A',
          accent: '#1E1B2E',
          success: '#2ECC71',
          info: '#3B82F6',
          warning: '#F59E0B',
          error: '#D32F2F',
          surface: '#FFFFFF',
          background: '#F7F7F7',
          font: '#ffffff',
          fontlight: '#000000',
        },
      },
    },
  });
// export default new Vuetify();
